module.exports = __webpack_public_path__ + "assets/media/system_success.b53bd91c.mp3";